module.exports = __webpack_public_path__ + "img/1535546560.5be0f1e7.jpg";